import { TranslateService } from '@ngx-translate/core';
import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpEventType } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Body } from '../models/body.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {

  methods = ['POST', 'PATCH', 'DELETE'];
  exceptions = ['login', 'backoffice/tags/list', 'fit/data', 'reset-password'];

  constructor(
    private toastr: ToastrService,
    // private translateService: TranslateService,
    private readonly injector: Injector) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    /*this.toastr.info('Este mensaje permanecerá visible hasta que lo cierres', 'Información', {
      timeOut: 0, // Nunca se cierra automáticamente
      closeButton: true, // Agrega botón de cierre
      tapToDismiss: false, // No se cierra al hacer clic
    });*/

    if (!this.methods.includes(request.method)) {
      return next.handle(request);
    }

    let title = '';
    let message = '';
    const translateService = this.injector.get(TranslateService)

    return next.handle(request).pipe(tap({
      next: res => {
        if (res.type !== HttpEventType.Response || this.exceptions.some(url => request.url.includes(url))) {
          return;
        }
        switch (request.method) {
          case 'POST':
            console.log(request);
            if (request.url.includes(environment.apiUrl)) {
              if (request.url == `${environment.apiUrl}/users`) {
                const body = (res as any).body;
                title = (body?.emailSent === false)
                  ? translateService.instant('TOAST.SUCCESS.SAVE')
                  : translateService.instant('TOAST.SUCCESS.SAVESENDEDEMAIL');
              } else {
                title = translateService.instant('TOAST.SUCCESS.SAVE');
              }
              this.toastr.success(message, title);
            } else {
              if (request.url.includes("screensaver")){
                title = translateService.instant('TOAST.SUCCESS.SCREENSAVERUPDATE')
              }else{
                title = translateService.instant('TOAST.SUCCESS.SEND');
              }
              this.toastr.success(message, title);
            }
            break;
          case 'PUT':
          case 'PATCH':
            title = translateService.instant('TOAST.SUCCESS.UPDATE');
            this.toastr.success(message, title);
            break;
          case 'DELETE':
            (request.body as Body)?.["mode"] == 'reset' || (request.body as Body)?.["recover"] == true
              ? title = translateService.instant('TOAST.SUCCESS.RESTORE')
              : title = translateService.instant('TOAST.SUCCESS.DELETE');
            this.toastr.success(message, title);
            break;
        }
        // if (res.body) {
        //   if (request.url.includes('settings')) {
        //     message = 'Settings ' + (res.body as Settings).loginToken;
        //   } else if (request.url.includes('entities')) {
        //     message = 'Entidad ' + (res.body as Entity).name;
        //   }
        // }

      },
      error: e => {
        if (request.url.includes('/bulk/')) return; // bulk operations handle their own error display
        title = 'Error';

        switch (request.method) {
          case 'POST':
            message = translateService.instant('TOAST.ERROR.SAVE');
            console.log(e);
            if (e.status === 400) {
              if (e.error?.error?.includes('already exists')) {
                message = translateService.instant('TOAST.ERROR.ALREADYEXIST')
              }
            }
            else if (e.status === 409) {
              message = translateService.instant('TOAST.ERROR.USERNAMEALREADYEXIST')
            }

            break;
          case 'PUT':
          case 'PATCH': message = translateService.instant('TOAST.ERROR.UPDATE'); break;
          case 'DELETE': message = translateService.instant('TOAST.ERROR.DELETE'); break;
        }

        if (request.url.includes('login')) {
          message = translateService.instant('TOAST.ERROR.LOGIN');
        }

        if (request.url.includes('reset-password') || request.url.includes('confirm') || request.url.includes('validate') || request.url.includes('resend')) {
          if (e.error.response) {
            const errorMessage = Array.isArray(e.error.response) 
              ? e.error.response[0] 
              : JSON.stringify(e.error.response);
            
            if (errorMessage.includes("User is already confirmed")) {
              return; // Silently ignore this error
            }
            
            if (errorMessage.includes("Verification code expired")) {
              return; // Silently ignore this error
            }
            
            if (errorMessage.includes("Invalid Verification code")) {
              return; // Silently ignore this error
            }

            if (errorMessage.includes("Resend not possible") || errorMessage.includes("status is not FORCE_CHANGE_PASSWORD")) {
              return; // Silently ignore this error
            }
            
            else {
              message = errorMessage;
            }
          }
        }

        this.toastr.error(message, title);
      }
    }));
  }

}
